import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { symbolTypesLabel as r, symbolTypesLabel3D as t } from "../../symbols.js";
import { JSONMap as o } from "../../core/jsonMap.js";
import { JSONSupport as n } from "../../core/JSONSupport.js";
import { clone as i } from "../../core/lang.js";
import { toPt as s } from "../../core/screenUtils.js";
import { property as l } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as a } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as c } from "../../core/accessorSupport/decorators/writer.js";
import b from "./LabelExpressionInfo.js";
import { templateStringToSql as u, getSingleFieldArcadeExpression as m, getLabelExpression as v, getLabelExpressionArcade as f, getLabelExpressionSingleField as w } from "./labelUtils.js";
import { defaultTextSymbol2D as S } from "../../symbols/support/defaults.js";
import { write as h } from "../../symbols/support/jsonUtils.js";

var _d;

var y = new o({
  esriServerPointLabelPlacementAboveCenter: "above-center",
  esriServerPointLabelPlacementAboveLeft: "above-left",
  esriServerPointLabelPlacementAboveRight: "above-right",
  esriServerPointLabelPlacementBelowCenter: "below-center",
  esriServerPointLabelPlacementBelowLeft: "below-left",
  esriServerPointLabelPlacementBelowRight: "below-right",
  esriServerPointLabelPlacementCenterCenter: "center-center",
  esriServerPointLabelPlacementCenterLeft: "center-left",
  esriServerPointLabelPlacementCenterRight: "center-right",
  esriServerLinePlacementAboveAfter: "above-after",
  esriServerLinePlacementAboveAlong: "above-along",
  esriServerLinePlacementAboveBefore: "above-before",
  esriServerLinePlacementAboveStart: "above-start",
  esriServerLinePlacementAboveEnd: "above-end",
  esriServerLinePlacementBelowAfter: "below-after",
  esriServerLinePlacementBelowAlong: "below-along",
  esriServerLinePlacementBelowBefore: "below-before",
  esriServerLinePlacementBelowStart: "below-start",
  esriServerLinePlacementBelowEnd: "below-end",
  esriServerLinePlacementCenterAfter: "center-after",
  esriServerLinePlacementCenterAlong: "center-along",
  esriServerLinePlacementCenterBefore: "center-before",
  esriServerLinePlacementCenterStart: "center-start",
  esriServerLinePlacementCenterEnd: "center-end",
  esriServerPolygonPlacementAlwaysHorizontal: "always-horizontal"
}, {
  ignoreUnknown: !0
});

function x(e) {
  return !e || "service" !== e.origin && !L(e.layer);
}

function L(e) {
  return "map-image" === (null == e ? void 0 : e.type);
}

function P(e) {
  var r, t;
  return !!L(e) && !(null == (r = e.capabilities) || null == (t = r.exportMap) || !t.supportsArcadeExpressionForLabeling);
}

function g(e) {
  return x(e) || P(e.layer);
}

var E = _d = /*#__PURE__*/function (_n) {
  _inherits(d, _n);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.type = "label", _this.name = null, _this.allowOverrun = !1, _this.deconflictionStrategy = "static", _this.labelExpression = null, _this.labelExpressionInfo = null, _this.labelPlacement = null, _this.labelPosition = "curved", _this.maxScale = 0, _this.minScale = 0, _this.repeatLabel = !0, _this.repeatLabelDistance = null, _this.symbol = S, _this.useCodedValues = void 0, _this.where = null;
    return _this;
  }

  _createClass(d, [{
    key: "readLabelExpression",
    value: function readLabelExpression(e, r) {
      var t = r.labelExpressionInfo;
      if (!t || !t.value && !t.expression) return e;
    }
  }, {
    key: "writeLabelExpression",
    value: function writeLabelExpression(e, r, t) {
      if (this.labelExpressionInfo) if (null != this.labelExpressionInfo.value) e = u(this.labelExpressionInfo.value);else if (null != this.labelExpressionInfo.expression) {
        var _r = m(this.labelExpressionInfo.expression);

        _r && (e = "[" + _r + "]");
      }
      null != e && (r[t] = e);
    }
  }, {
    key: "writeLabelExpressionInfo",
    value: function writeLabelExpressionInfo(e, r, t, o) {
      if (null == e && null != this.labelExpression && x(o)) e = new b({
        expression: this.getLabelExpressionArcade()
      });else if (!e) return;
      var n = e.toJSON(o);
      n.expression && (r[t] = n);
    }
  }, {
    key: "writeMaxScale",
    value: function writeMaxScale(e, r) {
      (e || this.minScale) && (r.maxScale = e);
    }
  }, {
    key: "writeMinScale",
    value: function writeMinScale(e, r) {
      (e || this.maxScale) && (r.minScale = e);
    }
  }, {
    key: "getLabelExpression",
    value: function getLabelExpression() {
      return v(this);
    }
  }, {
    key: "getLabelExpressionArcade",
    value: function getLabelExpressionArcade() {
      return f(this);
    }
  }, {
    key: "getLabelExpressionSingleField",
    value: function getLabelExpressionSingleField() {
      return w(this);
    }
  }, {
    key: "hash",
    value: function hash() {
      return JSON.stringify(this);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _d({
        allowOverrun: this.allowOverrun,
        deconflictionStrategy: this.deconflictionStrategy,
        labelExpression: this.labelExpression,
        labelExpressionInfo: i(this.labelExpressionInfo),
        labelPosition: this.labelPosition,
        labelPlacement: this.labelPlacement,
        maxScale: this.maxScale,
        minScale: this.minScale,
        name: this.name,
        repeatLabel: this.repeatLabel,
        repeatLabelDistance: this.repeatLabelDistance,
        symbol: i(this.symbol),
        where: this.where,
        useCodedValues: this.useCodedValues
      });
    }
  }], [{
    key: "evaluateWhere",
    value: function evaluateWhere(e, r) {
      var t = function t(e, r, _t) {
        switch (r) {
          case "=":
            return e == _t;

          case "<>":
            return e != _t;

          case ">":
            return e > _t;

          case ">=":
            return e >= _t;

          case "<":
            return e < _t;

          case "<=":
            return e <= _t;
        }

        return !1;
      };

      try {
        if (null == e) return !0;

        var _o = e.split(" ");

        if (3 === _o.length) return t(r[_o[0]], _o[1], _o[2]);

        if (7 === _o.length) {
          var _e = t(r[_o[0]], _o[1], _o[2]),
              _n2 = _o[3],
              _i = t(r[_o[4]], _o[5], _o[6]);

          switch (_n2) {
            case "AND":
              return _e && _i;

            case "OR":
              return _e || _i;
          }
        }

        return !1;
      } catch (o) {
        console.log("Error.: can't parse = " + e);
      }
    }
  }]);

  return d;
}(n);

e([l({
  type: String,
  json: {
    write: !0
  }
})], E.prototype, "name", void 0), e([l({
  type: Boolean,
  json: {
    write: !0,
    default: !1,
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], E.prototype, "allowOverrun", void 0), e([l({
  type: String,
  json: {
    write: !0,
    default: "static",
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], E.prototype, "deconflictionStrategy", void 0), e([l({
  type: String,
  json: {
    write: {
      overridePolicy: function overridePolicy(e, r, t) {
        return this.labelExpressionInfo && "service" === (null == t ? void 0 : t.origin) && P(t.layer) ? {
          enabled: !1
        } : {
          allowNull: !0
        };
      }
    }
  }
})], E.prototype, "labelExpression", void 0), e([a("labelExpression")], E.prototype, "readLabelExpression", null), e([c("labelExpression")], E.prototype, "writeLabelExpression", null), e([l({
  type: b,
  json: {
    write: {
      overridePolicy: function overridePolicy(e, r, t) {
        return g(t) ? {
          allowNull: !0
        } : {
          enabled: !1
        };
      }
    }
  }
})], E.prototype, "labelExpressionInfo", void 0), e([c("labelExpressionInfo")], E.prototype, "writeLabelExpressionInfo", null), e([l({
  type: y.apiValues,
  json: {
    type: y.jsonValues,
    read: y.read,
    write: y.write
  }
})], E.prototype, "labelPlacement", void 0), e([l({
  type: ["curved", "parallel"],
  json: {
    write: !0,
    origins: {
      "web-map": {
        write: !1
      },
      "web-scene": {
        write: !1
      },
      "portal-item": {
        write: !1
      }
    }
  }
})], E.prototype, "labelPosition", void 0), e([l({
  type: Number
})], E.prototype, "maxScale", void 0), e([c("maxScale")], E.prototype, "writeMaxScale", null), e([l({
  type: Number
})], E.prototype, "minScale", void 0), e([c("minScale")], E.prototype, "writeMinScale", null), e([l({
  type: Boolean,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1
      },
      "portal-item": {
        write: !1
      }
    }
  }
})], E.prototype, "repeatLabel", void 0), e([l({
  type: Number,
  cast: s,
  json: {
    write: !0,
    origins: {
      "web-scene": {
        write: !1
      }
    }
  }
})], E.prototype, "repeatLabelDistance", void 0), e([l({
  types: r,
  json: {
    origins: {
      "web-scene": {
        types: t,
        write: h,
        default: null
      }
    },
    write: h,
    default: null
  }
})], E.prototype, "symbol", void 0), e([l({
  type: Boolean,
  json: {
    write: !0
  }
})], E.prototype, "useCodedValues", void 0), e([l({
  type: String,
  json: {
    write: !0
  }
})], E.prototype, "where", void 0), E = _d = e([p("esri.layers.support.LabelClass")], E);
var j = E;
export { j as default };